export default {"src":"/_next/static/media/gif_logo_loading.990bd877.gif","height":1200,"width":1200,"blurWidth":0,"blurHeight":0};